import { mutator } from 'satcheljs';
import getStore from '../store/store';
import createService from '../actions/createService';

/**
 * Add a new service to the existing services in the store.
 */
export default mutator(createService, actionMessage => {
    let store = getStore();
    store.services.set(actionMessage.service.ServiceId, actionMessage.service);
});
